export default "__VITE_ASSET__1a3200d8__"